module.exports = { "default": require("core-js/library/fn/array/slice"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/slice.js
// module id = 466
// module chunks = 2